import DeleteIcon from '@mui/icons-material/Delete';
import {Box, IconButton, Tooltip, Typography} from '@mui/material';
import {request_remove_order} from 'connector/order';
import {useActiveOrders} from 'hooks/orderHooks';
import {IOrder} from 'types';

export default function RemoveButton(props: {index: number; order: IOrder; is_processing: boolean; set_is_processing: (is_processing: boolean) => void}) {
	const {is_processing, set_is_processing, index, order} = props;

	const {remove_order} = useActiveOrders();

	const handleClick = async (order_id?: string) => {
		if (!order_id || is_processing) return;
		set_is_processing(true);

		request_remove_order(order_id).then(resp => {
			if (resp.code === 200 || resp.code === 402) remove_order(order_id);
			else console.error(resp);

			setTimeout(() => set_is_processing(false), 500);
		});
	};

	const is_disabled = (order.state !== 'closed' && order.state !== 'canceled' && order.state !== 'open_watch') || is_processing || order.archived;

	const buttonSize = '25px';

	return (
		<Tooltip title={`Order ID: ${order.order_id}`} arrow placement="top">
			<Box position="relative">
				<IconButton onClick={() => handleClick(order.order_id)} disabled={is_disabled} sx={{padding: 0}}>
					{order.archived ? (
						<Box width={buttonSize} height={buttonSize} borderRadius="50px" border="2px solid" borderColor={(order.profit ?? 0) > 0 ? 'primary.main' : 'error.main'} />
					) : (
						<DeleteIcon sx={{fontSize: buttonSize, color: 'text.disabled'}} />
					)}

					<Typography variant="caption" color={order.archived ? 'black' : 'white'} position="absolute" top="55%" left="50%" sx={{transform: 'translate(-50%, -50%)'}}>
						{index + 1}
					</Typography>
				</IconButton>
			</Box>
		</Tooltip>
	);
}
